import { dispatch } from '../redux/store';
import { apiSlice } from '../redux/slices/apiSlice';
import { getUnixTimeEndOfDay } from './timeAndDateHelper';

export function setApplicationTimestamp(timestamp: number) {
  localStorage.setItem('applicationTimestamp', timestamp.toString());
  dispatch(apiSlice.util.resetApiState());
}

export function getApplicationTimestamp() {
  const timestamp = localStorage.getItem('applicationTimestamp');
  if (!timestamp) {
    // this is just for the initial start when no localStorage-entry is present
    // e.g. first login of user or first start in different browser
    setApplicationTimestamp(getUnixTimeEndOfDay(new Date()));
    window.location.reload();
  }
  return Number(timestamp);
}
